import React, { useLayoutEffect } from "react";
import { Navigate, useParams } from "react-router";
import { useMandatorContext } from "@rentablo/theming";
import { LoginPage } from "./LoginPage";
import { MANDATOR_LOGIN_BY_SEGMENT } from "./mandatorLoginConfig";

export const LoginMandatorRoute = () => {
  const { mandatorSegment } = useParams<{ mandatorSegment: string }>();
  const { setLocalMandatorSlug } = useMandatorContext();

  const entry = mandatorSegment
    ? MANDATOR_LOGIN_BY_SEGMENT[mandatorSegment]
    : undefined;

  useLayoutEffect(() => {
    if (entry) {
      setLocalMandatorSlug(entry.mandator);
    }
  }, [entry, setLocalMandatorSlug]);

  if (!mandatorSegment || !entry) {
    return <Navigate to="/login" replace />;
  }

  return <LoginPage showSSO={entry.showSSO} />;
};
